module.exports = __webpack_public_path__ + "5ed2a402c2ede2b78676ae119c41a818.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ailerons.woff
// module id = 133
// module chunks = 0